import gql from 'graphql-tag';

export const BREADCRUMBS_FRAGMENT = gql`
    fragment BREADCRUMBS_FRAGMENT on Breadcrumbs {
        label
        tracking
        uri
        noAppend
        i18nLabelKey
    }
`;
